import { Footer } from '../../CommonComponents'
import Header from '../../CommonComponents/Header/HeaderContainer'
import './Layout.scss'
import {useSelector} from 'react-redux'
import { useLocation } from 'react-router-dom'
import { ASSET_INVENTORY_CONSTANTS } from 'client/utils/constants/assetInventory'
import { useEffect } from 'react'

interface IProps {
  children?: any,
  showMenu?: any
  toggleDropdown?: any,
  wrapperRef?:any
}
const Layout = ({ children, showMenu, toggleDropdown,wrapperRef }: IProps) => {

  const userMenuList = [
    {
      link: '/',
      text: 'Branch',
      icon: 'branch'
    },
    {
      link: '/',
      text: 'Settings',
      icon: 'settings'
    }
  ]
  const activeNavigation = useSelector((state:any) => state.nav.nav)
  const menu = useSelector((state:any)=>state.nav.showMenu)
  const path = useLocation();
  const pathName = path?.pathname?.split("/")[1];

  useEffect(() => {
    const contentWrapper = document.querySelector(".content-wrapper") as HTMLElement;

    const handleScroll = () => {
      const dateMenu = document.querySelector(".rs-picker-menu") as HTMLElement;
      if (dateMenu) {
        dateMenu.style.display = "none";
      }
    };

    if (contentWrapper) {
      contentWrapper.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (contentWrapper) {
        contentWrapper.removeEventListener("scroll", handleScroll);
      }
    };
  }, []);

  return (
    <div className='main-wrapper'>
      <Header heading={'LEADR  VISION'} showMenu={showMenu} toggleDropdown={toggleDropdown} userMenuList={userMenuList} data-attribute="Layout_Default_Header_2" />
      <div className={`someClass ${ activeNavigation !== null ? 'activeHome ' : '' }`} ref={wrapperRef}>
      <div className={`content-wrapper ${activeNavigation =="Non-Standard Equipment" ||activeNavigation =="My Orders"|| activeNavigation =="Managed Equipment "? 'home closeFreeze': menu ? 'home': ''}  ${pathName?.toLowerCase() === ASSET_INVENTORY_CONSTANTS.ASSET_INVENTORY_PATHNAME || pathName?.toLowerCase() === "activeasset" ?  'asset-inventory-mobile' : ''}`}>
        { children }
      </div>
      <div className='clearfix'></div>
      <Footer  data-attribute="Layout_Default_Footer" />
      </div>
    </div>
  )
}

export default Layout
